// Анти-open-redirect (VF-001): дозволяємо лише внутрішній абсолютний шлях — рівно
// один провідний "/", далі НЕ "/" і НЕ "\" (інакше protocol-relative "//host" або
// "/\host", який браузер нормалізує до "//host"), і без control-символів
// (CR/LF/TAB тощо, які теж можуть змінити інтерпретацію). Інакше — fallback.
const INTERNAL_PATH = /^\/(?![/\\])/;

function hasControlChars(value: string): boolean {
  for (let i = 0; i < value.length; i += 1) {
    const code = value.charCodeAt(i);
    if (code < 0x20 || code === 0x7f) return true;
  }
  return false;
}

export function safeInternalPath(
  raw: string | null | undefined,
  fallback: string,
): string {
  if (!raw) return fallback;
  if (!INTERNAL_PATH.test(raw)) return fallback;
  if (hasControlChars(raw)) return fallback;
  return raw;
}
